/** Cancels stale asynchronous boarding without cancelling the shared import. */
export class RunLaunchScope {
  private current: AbortController | null = null;

  public begin(): AbortSignal {
    this.cancel();
    this.current = new AbortController();
    return this.current.signal;
  }

  public cancel(): void {
    this.current?.abort();
    this.current = null;
  }

  public get active(): boolean { return this.current !== null; }
}
